<template>
  <body
    id="kt_body"
    class="header-fixed header-tablet-and-mobile-fixed toolbar-enabled"
  >
    <Header
      v-if="showHeaderAndNavDrawer"
      :reload="reloadNotification"
      @reset="resetNotifVariable"
      @showNotifier="showNotifier"
      @showNavDrawer="showNavDrawer"
    />

    <div class="spacer-y-10" v-if="showHeaderAndNavDrawer"></div>
    <div
      id="kt_content_container"
      class="d-flex flex-column-fluid align-items-start container-xxl"
    >
      <!--begin::Post-->
      <div class="content flex-row-fluid" id="kt_content">
        <!--begin::Row-->

        <router-view @updateNotification="reload"></router-view>
        <NavigationDrawer v-if="displayNavDrawer && showHeaderAndNavDrawer" @closeNavDrawer="hideNavDrawer"/>
        <!--end::Row-->
      </div>
      <!--end::Post-->
    </div>
    <div class="spacer-y-10"></div>
    <div class="spacer-y-10"></div>
    <SnackbarNotifier
      :isShow="isShowSnackBar"
      :message="responseMessage"
      :snackType="snackbarType"
      :colour="snackBarColour"
      @eReset="resetSnackBar"
    />
    <Footer />
  </body>
</template>

<script>
require("@/assets/plugins/custom/fullcalendar/fullcalendar.bundle.css");
require("@/assets/plugins/global/plugins.bundle.css");
require("@/assets/css/style.bundle.css");
require("@/assets/css/fonts.css");

import mixins from "vue-typed-mixins";
import Footer from "@/components/Footer.vue";
import SnackbarNotifier from "@/components/SnackbarNotifier.vue";
import SnackbarNotifierMixin from "@/mixins/SnackbarNotifierMixins";
import NavigationDrawer from "@/components/NavigationDrawer.vue";

export default mixins(SnackbarNotifierMixin).extend({
  name: "Home",
  data: () => ({
    reloadNotification: false,
    displayNavDrawer: false
  }),
  components: {
    SnackbarNotifier,
    Footer,
    Header: () => import("@/components/Header.vue"),
    NavigationDrawer,
  },
  computed: {
    showHeaderAndNavDrawer() {
      var doNotShowOnThesePages = [
        "ConsigneeDocumentUploadLogin",
        "Login",
        "Signup",
        "Signout",
        "Resetpassword",
        "Logout",
        "ConfirmAccount",
        "PageNotFound",
        "ContactUs",
        "ForgotPassword",
        "ResetPassword",
        "FAQ"
      ];
      return !doNotShowOnThesePages.includes(this.$route.name);
    },
  },
  methods: {
    reload(){
      this.reloadNotification = true;
    },
    resetNotifVariable(){
      this.reloadNotification = false;
    },
    showNavDrawer(){
      this.displayNavDrawer = true;
    },
    hideNavDrawer(){
      this.displayNavDrawer = false;
    }
  }
});
</script>
